// extracted by mini-css-extract-plugin
export default {"pageLayout":"Reports_pageLayout__4I-Ae"};